// apps/marketing-site entry point.
//
// Per AGENTS.md's Astryx setup rule (the same principle applied to site-theme): the shared token and
// component CSS are imported once, here, before anything renders — never per component, or a second
// import would silently reset custom properties a tenant's theme override sets.
import "@lovehoa/site-theme/tokens.css";
import "@lovehoa/site-theme/site-theme.css";

import { createRoot } from "react-dom/client";
import { App } from "./App.js";

const container = document.getElementById("root");
if (!container) {
  throw new Error("apps/marketing-site: #root element not found in index.html");
}

createRoot(container).render(<App />);
